// target specific browser

// safari browser
export default function safariBrowser() {    
    if (navigator.vendor.includes('Apple')) return true;
    return false;
}